import { useContext, useEffect, useState } from "react";

import { CAPITAL_LOGO } from "../assets";
import { authService, regexService } from "../service";
import { loaderContext, notificationContext } from "../context/context";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [userID, setuserID] = useState("");
  const toast = useContext(notificationContext);
  const { showLoader, hideLoader } = useContext(loaderContext);

  const validateUserID = async () => {

    showLoader();
    try {
      const response = await authService.validateADID(userID);
      if (response.data) {
        window.location.replace(response.data.responsepageURL);
      }
      if (response.error) {
        throw response.error;
      }
    } catch (error) {
      toast.error(error?.message);
      hideLoader();
    }
  };

  const checkCode = async () => {
    const searchParam = new URLSearchParams(window.location.search);
    if (searchParam.get("code")) {
      showLoader();
      const response = await authService.handleLogin(searchParam.get("code"));

      if (response?.data) {
        sessionStorage.setItem("userDetail", authService.enc(response.data));
        navigate(0);
      }

      if (response.error) {
        toast.error(response?.error?.message);
        setTimeout(() => {
          navigate("");
        }, 3000);
      }

      hideLoader();
    }
  };

  useEffect(() => {
    checkCode();
  }, []);

  return (
    <div className="page-wrapper">
      <div className="flex flex-col flex-md-row flex-md-wrap wrapper">
        <div className="fc-12 fc-md-6 bg-primary p-2 p-md-3">
          <img src={CAPITAL_LOGO} alt="logo" className="abc-logo" />
        </div>
        <div className="flex-expand fc-12 fc-md-6 py-3 px-md-4 ">
          <div className="flex flex-col cover">
            <div className="h-100 flex-center">
              <div className="container">
                <h3>Welcome Back</h3>
                <p className="text-1">Login to continue</p>
                <div className="mt-4">
                  <div className="input-wrapper fc-10 pt-1">
                    <div className="input-title">UserID</div>
                    <label className="input" htmlFor="adid">
                      <input
                        value={userID}
                        type="text"
                        placeholder="Enter your UserID"
                        id="adid"
                        onChange={(e) =>
                          regexService.isUserID(e.target.value) &&
                          setuserID(e.target.value)
                        }
                      />
                    </label>
                  </div>
                  <button className="btn-primary" onClick={validateUserID}>
                    Continue
                  </button>
                </div>
              </div>
            </div>
            {/* <div>
              <p className="text-secondary mini-text text-center">
                <a href="#">Privacy</a> and <a href="#">Term of service</a>
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
